/** Extract readable message from API validation/auth errors. */
export function getApiErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  if (data.message) return data.message;
  if (Array.isArray(data.errors)) return data.errors.join(' ');
  if (data.errors && typeof data.errors === 'object') {
    return Object.values(data.errors).flat().join(' ');
  }
  if (data.title && data.status === 400) return 'Please check your details and try again.';
  return fallback;
}

export const PASSWORD_HINT = 'At least 8 characters with uppercase, lowercase, and a number (e.g. User@123)';
